import React from 'react';
import { Tooltip as MuiTooltip } from '@mui/material';
import { cn } from '@/lib/utils';

interface MaterialTooltipProps {
  title: string;
  children: React.ReactElement;
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'top-start' | 'top-end' | 'bottom-start' | 'bottom-end' | 'left-start' | 'left-end' | 'right-start' | 'right-end';
  className?: string;
  arrow?: boolean;
  enterTouchDelay?: number;
  leaveTouchDelay?: number;
  maxWidth?: string;
}

export const MaterialTooltip: React.FC<MaterialTooltipProps> = ({
  title,
  children,
  placement = 'top',
  className,
  arrow = true,
  enterTouchDelay = 0,
  leaveTouchDelay = 3000,
  maxWidth = '320px',
  ...props
}) => {
  return (
    <MuiTooltip
      title={title}
      placement={placement}
      arrow={arrow}
      enterTouchDelay={enterTouchDelay}
      leaveTouchDelay={leaveTouchDelay}
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: 'rgba(17, 24, 39, 0.95)',
            color: 'white',
            fontSize: '0.875rem',
            maxWidth: maxWidth,
            padding: '8px 12px',
            borderRadius: '8px',
            '& .MuiTooltip-arrow': {
              color: 'rgba(17, 24, 39, 0.95)',
            }
          }
        }
      }}
      {...props}
    >
      {React.cloneElement(children, {
        className: cn(children.props.className, className)
      })}
    </MuiTooltip>
  );
};
